import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const WidgetInitializer = () => {
  const location = useLocation();

  useEffect(() => {
    // Reinitialize HireX8 Widget after route changes
    const initHireX8Widget = () => {
      const buttons = document.querySelectorAll('.hire-widget');
      
      if (buttons.length > 0) {
        buttons.forEach(function(button) {
          // Remove any existing listeners to prevent duplicates
          const newButton = button.cloneNode(true);
          button.parentNode.replaceChild(newButton, button);
          
          // Add fresh click handler
          newButton.addEventListener('click', function(e) {
            e.preventDefault();
            if (window.HireX8Widget && typeof window.HireX8Widget.open === 'function') {
              window.HireX8Widget.open();
            }
          });
        });
        console.log('HireX8 Widget reinitialized for', buttons.length, 'buttons on route:', location.pathname);
      }
    };

    // Small delay to ensure DOM is ready after component mount
    const timer = setTimeout(initHireX8Widget, 100);
    
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return null;
};

export default WidgetInitializer;
